<script setup lang="ts">
import type { NoticeItem } from '@/types/notice'
import { socketEmit } from '@/utils/web-socket'
import { onMounted, ref } from 'vue'

const noticeList = ref<NoticeItem[]>([])
const curNotice = ref()

onMounted(() => {
  socketEmit<NoticeItem[]>({
    type: 'getNoticeList',
    callBack: (res) => {
      noticeList.value = res.data.map((item) => {
        const content = `<p>${item.content.replace(/\n/g, '</p><p>')}</p>`
        const el = document.createElement('div')
        el.innerHTML = content
        const elChildren = el.children
        for (let i = 0; i < elChildren.length; i++) {
          const text = elChildren[i].textContent
          if (!text) continue
          if (/^(ix|iv|i{0,3})$/.test(text.slice(0, 1)) && elChildren[i - 1].textContent?.slice(0, 1) !== 'h') {
            elChildren[i].classList.add('p-3')
          } else if (/^[a-z]/.test(text.slice(0, 1))) {
            elChildren[i].classList.add('p-2')
          }
        }
        return {
          ...item,
          content: el.innerHTML,
        }
      })
      curNotice.value = res.data[0].id
    },
  })
})
</script>

<template>
  <div class="notice">
    <el-collapse v-model="curNotice">
      <el-collapse-item v-for="item of noticeList" :title="item.title" :name="item.id">
        <div v-html="item.content"></div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<style lang="scss" scoped>
.notice {
  max-height: 50vh;
  overflow: auto;
  :deep() {
    p {
      margin: 4px 0;
    }
    .p-2 {
      text-indent: 2em;
    }
    .p-3 {
      text-indent: 4em;
    }
  }
}
</style>
